import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import useHoverHandlersDelay from '@elliemae/ds-utilities/hooks/useHoverHandlersDelay';
import { useHiddenController } from '@elliemae/ds-hidden';
import Popover from './Popover.js';
import usePopper from './usePopper.js';
export { default as usePopper } from './usePopper.js';
import Arrow from './Arrow.js';
export { default as usePopoverProviderState } from './usePopoverProviderState.js';
export * from '@elliemae/ds-popper';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'lodash';
import '@elliemae/ds-classnames';
import '@elliemae/ds-utilities/utils';
import '@elliemae/ds-utilities/hooks';
import '@elliemae/ds-portal';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'popper.js';
import '@elliemae/ds-popper/getArrowStylesBySize';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Interaction = {
  CLICK: 'click',
  HOVER: 'hover'
};
/* Unstable Popover, not yet fully working */

var DSPopover = function DSPopover(_ref) {
  var containerProps = _ref.containerProps,
      content = _ref.content,
      renderer = _ref.renderer,
      visibleProp = _ref.visible,
      offset = _ref.offset,
      showArrow = _ref.showArrow,
      placement = _ref.placement,
      boundaries = _ref.boundaries,
      modifiers = _ref.modifiers,
      referenceEl = _ref.referenceEl,
      renderTrigger = _ref.renderTrigger,
      onClickOutside = _ref.onClickOutside,
      destroyOnHidden = _ref.destroyOnHidden,
      interactionType = _ref.interactionType,
      isOpen = _ref.isOpen,
      style = _ref.style;

  var _useHiddenController = useHiddenController(visibleProp),
      visible = _useHiddenController.visible,
      onShow = _useHiddenController.onShow,
      onHide = _useHiddenController.onHide,
      onToggle = _useHiddenController.onToggle;

  var _usePopper = usePopper({
    placement: placement,
    showArrow: showArrow,
    boundaries: boundaries,
    modifiers: modifiers,
    offset: offset,
    referenceEl: referenceEl,
    eventsEnabled: visible,
    isOpen: isOpen
  }),
      reference = _usePopper.reference,
      popper = _usePopper.popper,
      arrow = _usePopper.arrow,
      popperData = _usePopper.popperData;

  var hoverHandlers = useHoverHandlersDelay({
    onMouseOver: onShow,
    onMouseLeave: onHide
  });
  var isPopoverVisible = visible || isOpen;
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderTrigger(_objectSpread(_objectSpread({}, reference), {}, {
    handlers: hoverHandlers,
    onShow: onShow,
    onToggle: onToggle,
    onHide: onHide,
    'aria-haspopup': true,
    'aria-expanded': visible
  })), isPopoverVisible && reference.ref && /*#__PURE__*/React.createElement(Popover, {
    containerProps: containerProps,
    destroyOnHidden: destroyOnHidden,
    interactionType: interactionType,
    isOpen: isOpen,
    onClickOutside: onClickOutside,
    popperProps: popper,
    renderer: renderer && function (props) {
      return renderer(_objectSpread(_objectSpread({}, props), {}, {
        onShow: onShow,
        onToggle: onToggle,
        onHide: onHide
      }));
    },
    style: style,
    visible: isPopoverVisible
  }, showArrow && /*#__PURE__*/React.createElement(Arrow, _extends({}, arrow, {
    placement: popperData.placement
  })), isPopoverVisible && content));
};

DSPopover.defaultProps = {
  containerProps: {},
  renderer: undefined,
  visible: undefined,
  offset: undefined,
  showArrow: false,
  placement: 'top',
  modifiers: {},
  renderTrigger: function renderTrigger() {
    return null;
  },
  onClickOutside: function onClickOutside() {
    return null;
  },
  destroyOnHidden: true,
  isOpen: undefined
};
var popoverProps = {
  containerProps: PropTypes.shape({}).description('Set of Properties attached to the main container'),
  destroyOnHidden: PropTypes.bool.description('destroy popover on hidden or not').defaultValue(true),
  renderer: PropTypes.func.description('custom renderer'),
  popperProps: PropTypes.object.description('Popper props attached to container'),
  visible: PropTypes.bool.description('is visible or not').defaultValue(false),
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).description('popover content'),
  onClickOutside: PropTypes.func.description('function called on click outside'),
  interaction: PropTypes.string.description('interaction type: hover, click'),
  offset: PropTypes.object.description('offset'),
  showArrow: PropTypes.bool.description('show tooltip arrow or not'),
  placement: PropTypes.string.description('popover placement: top, bottom, right, left'),
  boundaries: PropTypes.string.description('popover boundaries'),
  modifiers: PropTypes.object.description('modifiers'),
  style: PropTypes.object.description('css style object'),
  referenceEl: PropTypes.element.description('reference element'),
  renderTrigger: PropTypes.func.description('render trigger element'),
  interactionType: PropTypes.string.description('interaction type'),
  isOpen: PropTypes.bool.description('open or not').defaultValue(false)
};
DSPopover.propTypes = popoverProps;
var PopoverWithSchema = describe(DSPopover);
PopoverWithSchema.propTypes = popoverProps;

export default DSPopover;
export { DSPopover, Interaction, PopoverWithSchema };
//# sourceMappingURL=DSPopover.js.map
